






import Vue from "vue";
import { Component } from "vue-property-decorator";
import Game, { GameType } from "@/components/Game.vue";
import views from "@/views/Views";

@Component({
  components: {
    Game,
  },
})
export default class MultiPath extends Vue {
  type: GameType = GameType.MULTIPATH;
  title = views.find((el) => el.component === GameType.MULTIPATH).title;
  video = "normalto.mp4";
}
